import React from "react";
import { __ } from '@wordpress/i18n';
const bannerImage = `${EASYCOMMERCE.assets}admin/img/icons/default-banner.svg`;

const Default = ({ handleNext }) => {
    return (
        <div className="pt-8 w-full bg-ec-main-bg">
            <div
                className="mb-12 w-[870px] px-[70px] pt-[120px] pb-[80px] mx-auto object-contain bg-white rounded-[20px]"
                style={{ backgroundImage: `url(${bannerImage})`, backgroundRepeat: "no-repeat" }}
            >
                {/* Updated headline with outcome-focused messaging */}
                <h2 className="text-ec-title text-[32px] leading-[42px] text-center font-semibold font-inter">
                    {__("Your Store Is Almost Ready!", "easycommerce")}
                </h2>
                
                {/* Benefit-driven subheading with quantifiable promise */}
                <p className="text-ec-body text-base text-center font-normal mt-8 font-inter max-w-[650px] mx-auto">
                    {__("Start selling in a few minutes with 4 easy steps and enjoy features including:", "easycommerce")}
                </p>
                
                {/* Benefit-driven subheading with quantifiable promise */}
                <div className="mt-6 max-w-[600px] mx-auto">
                    <ul className="mt-4 grid grid-cols-2 gap-x-10 gap-y-2">
                        {[
                            __("Free AI writer", "easycommerce"),
                            __("Abandoned Cart Recovery", "easycommerce"),
                            __("Robust Dashboard and Reports", "easycommerce"),
                            __("Real-time Inventory Tracking", "easycommerce"),
                            __("Shipping and Taxation Handling", "easycommerce"),
                            __("Drag-and-Drop Builder, and more..", "easycommerce")
                        ].map((item, index) => (
                            <li key={index} className="flex items-start">
                                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 mt-0.5 mr-2 text-ec-primary flex-shrink-0" viewBox="0 0 20 20" fill="currentColor">
                                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                                </svg>
                                <span className="text-ec-body text-base">{item}</span>
                            </li>
                        ))}
                    </ul>
                </div>

                {/* Consolidated CTAs with visual hierarchy */}
                <div className="flex flex-col items-center mt-[39px]">
                    {/* Primary CTA as single focus point */}
                    <button
                        onClick={handleNext}
                        type="button"
                        className="w-[230px] h-14 font-inter bg-ec-primary group border border-ec-primary 
                        rounded-lg text-white font-medium hover:text-white hover:bg-ec-secondary 
                        focus:shadow-none text-lg transition-all ease-in-out duration-300 
                        leading-[26px] flex items-center justify-center gap-2 shadow-md hover:shadow-lg"
                    >
                        {__("Get Started Now", "easycommerce")}
                        <img 
                            src={`${EASYCOMMERCE.assets}admin/img/icons/wizard-arrow-right.png`} 
                            alt="" 
                            className="ml-2 w-4 h-[11px] object-contain"
                        />
                    </button>
                    
                    {/* Secondary progressive disclosure */}
                    <a
                        href="https://tastewp.com/recipe/easycommerce"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="mt-5 font-inter flex items-center text-ec-body hover:text-ec-primary text-base font-normal group"
                    >
                        {__("Try the instant demo — no signup needed", "easycommerce")}
                        <svg 
                            xmlns="http://www.w3.org/2000/svg" 
                            className="ml-2 h-4 w-4 group-hover:translate-x-1 transition-transform"
                            fill="none" 
                            viewBox="0 0 24 24" 
                            stroke="currentColor"
                        >
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                        </svg>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default Default;